import React from 'react';
const Header = (props) => {
    const { userAvatar, firstName, dateCreated, textColor } = props;
    return (React.createElement("div", { className: 'header' },
        React.createElement("div", { className: 'user-avatar' },
            React.createElement("img", { src: userAvatar, width: '100%', height: '100%' })),
        React.createElement("div", null,
            React.createElement("p", { className: 'user-name', style: { color: textColor } }, firstName),
            React.createElement("p", { className: 'date', style: { color: textColor } }, dateCreated))));
};
export { Header };
